import { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export const PasswordInput = forwardRef(function PasswordInput({ testid, ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} type={show ? "text" : "password"} className="pr-10" data-testid={testid} {...props} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        aria-label={show ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground transition-colors hover:text-foreground"
      >
        {show ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
});
